import React from "react";


const Team = () => {
  return (
    <section id="team" className="team-section">
      {/* <h2 className="team-title">Meet Our Team</h2> */}
      <p className="team-intro">
        At Zirae Chemicals, our team blends expertise with creativity to bring
        transformative solutions to the chemical industry. Each member combines
        leadership and vision to drive growth and innovation.
      </p>

      <div className="team-container">
        {/* Team Member 1 */}
        <div className="team-card">
          <div className="team-header">
            <img
              src="https://randomuser.me/api/portraits/men/32.jpg"
              alt="Dr. John Carter"
              className="team-img"
            />
            <div className="team-info">
              <h3>Mrs Misturah O. Olajide </h3>
              <span className="team-role">Director</span>
            </div>
          </div>
          <p className="team-bio">
            Zirae chemicals was born from more thab just business, its legacy. Misturahgrew up around chemicals, paints and art of building finishes. What started as family heritage is now Zirae chemicals. A company she leads with mission to transform spaces with durability, beauty, innovation & excellence. With deep respect for deatails she leads Zirae into projects that don't just meet the standard but set them.
          </p>
        </div>

        {/* Team Member 2 */}
        <div className="team-card">
          <div className="team-header">
            <img
              src="https://randomuser.me/api/portraits/women/44.jpg"
              alt="Dr. Linda Smith"
              className="team-img"
            />
            <div className="team-info">
              <h3>Dr. Lawal Olaniyi Moshood </h3>
              <span className="team-role">Project Supervisor</span>
            </div>
          </div>
          <p className="team-bio">
            Olaniyi oversees our painting and POP projects, amking sure every details is handled with care and delivered 
            to standard. With a strong background in property management and  real estate, he brings a wider understanding of 
            how quality finishes increase both comfort and value. At zirea, his role is clear (to guide teams on-site
            and ensure clients get results they're proud of.)
          </p>
        </div>
      </div>
    </section>
  );
};

export default Team;
